import { useScrollPosition } from '@n8tb1t/use-scroll-position'
import { Icon } from '@pickupp/ui/core'
import { makeStyles } from '@pickupp/ui/styles'
import cx from 'classnames'
import React, { useState } from 'react'

import { BROWSER } from '~/config'
import { useIsMobile } from '~/src/hooks'

import styles from './styles'

const useStyles = makeStyles(styles)

const BackToTopButton = () => {
  const isMobile = useIsMobile()
  const classes = useStyles()
  const [scrollUp, setScrollUp] = useState(false)
  const { scrollHeight } = BROWSER && document.documentElement

  useScrollPosition(({ prevPos, currPos }) => {
    // setScrollUp when the page is not at the top
    if ((currPos.y > prevPos.y) && (currPos.y < 0)) {
      setScrollUp(true)
    } else {
      setScrollUp(false)
    }
  }, [scrollUp])

  const shouldShowButton = scrollUp && (scrollHeight > (isMobile ? 896 : 3072))

  return (
    <div
      className={cx(classes.button, {
        [classes.showButton]: shouldShowButton,
      })}
      onClick={() => window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })}
      aria-hidden
    >
      <Icon
        color="darkGrey"
        name="arrow_upward"
        className={classes.backIcon}
      />
    </div>
  )
}

export default BackToTopButton
